import auth from './Auth'
import application from './Application'
import user from './User'
import {combineReducers} from 'redux';
export default combineReducers({
    auth,
    application,
    user
})